// import React, { useState, useEffect } from 'react'
// import { DataGrid } from '@mui/x-data-grid'
// import { Box } from '@mui/material'
// import apiClient from '../../../clients/ApiClient'
// import io from 'socket.io-client'

// // const socket = io('http://api.asconlineportal.com/api') // Replace with your backend's WebSocket URL
// const socket = io('https://api.asconlineportal.com', {
//     path: '/socket.io/', // Default Socket.IO path
//     transports: ['websocket'] // Use WebSocket transport
// })
// // Adjust as needed

// const OTAttendanceTodayList = () => {
//     const [employees, setEmployees] = useState([]) // State to store employee data
//     const [loading, setLoading] = useState(true) // Loading state

//     // Fetch DTR data from the API
//     const fetchDtrData = async () => {
//         try {
//             const today = new Date()
//             const dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString() // Start of today
//             const dateEnd = new Date(
//                 today.getFullYear(),
//                 today.getMonth(),
//                 today.getDate(),
//                 23,
//                 59,
//                 59,
//                 999
//             ).toISOString() // End of today

//             const attendance = {
//                 dateStart: dateStart,
//                 dateEnd: dateEnd
//             }

//             const response = await apiClient.get('/overtime/', {
//                 params: attendance
//             })

//             const formattedData = response.data
//                 .map((employee, index) => {
//                     const record = employee.dailyTimeRecord && employee.dailyTimeRecord[0]
//                     if (!record) {
//                         return null
//                     }

//                     return {
//                         id: index + 1,
//                         name: employee.fullName,
//                         timeIn: record.timeIn === null ? '-' : new Date(record.timeIn).toLocaleTimeString(),
//                         timeOut: record.timeOut === null ? '-' : new Date(record.timeOut).toLocaleTimeString(),
//                         remarks: record.remarks === null ? '-' : record.remarks
//                     }
//                 })
//                 .filter(Boolean)

//             setEmployees(formattedData)
//             setLoading(false)
//         } catch (error) {
//             console.error('Error fetching DTR data:', error)
//             setLoading(false)
//         }
//     }

//     useEffect(() => {
//         fetchDtrData()

//         socket.on('otAttendanceUpdated', (updatedAttendance) => {
//             console.log('Attendance Updated:', updatedAttendance)
//             fetchDtrData()
//         })

//         return () => {
//             socket.off('otAttendanceUpdated')
//         }
//     }, [])

//     // Define columns for the DataGrid
//     const columns = [
//         { field: 'name', headerName: 'Name', width: 250 },
//         { field: 'timeIn', headerName: 'Time In', width: 150 },
//         { field: 'timeOut', headerName: 'Time Out', width: 150 },
//         {
//             field: 'remarks',
//             headerName: 'Remarks',
//             width: 150,
//             renderCell: (params) => {
//                 const remark = params.value
//                 const bgColor = remark === 'Home' ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'
//                 return <span className={`px-3 py-1 rounded-full font-semibold ${bgColor}`}>{remark}</span>
//             }
//         }
//     ]

//     return (
//         <Box sx={{ height: '75%', width: 700 }}>
//             <h2 className="text-xl font-semibold mb-4">Overtime Attendance Today</h2>
//             <DataGrid
//                 className="bg-white"
//                 rows={employees}
//                 columns={columns.map((column) => ({
//                     ...column,
//                     headerClassName: 'header-bold'
//                 }))}
//                 pageSize={10}
//                 rowsPerPageOptions={[10]}
//                 loading={loading}
//                 disableSelectionOnClick
//                 sx={{
//                     '& .MuiDataGrid-columnHeaders': {
//                         fontWeight: 'bold'
//                     },
//                     '& .MuiDataGrid-cell': {
//                         cursor: 'default',
//                         pointerEvents: 'none'
//                     }
//                 }}
//             />
//         </Box>
//     )
// }

// export default OTAttendanceTodayList

import React, { useState, useEffect } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { Box, Typography } from '@mui/material'
import apiClient from '../../../clients/ApiClient'
import io from 'socket.io-client'

const socket = io('https://api.asconlineportal.com', {
    path: '/socket.io/',
    transports: ['websocket']
})

const OTAttendanceTodayList = () => {
    const [employees, setEmployees] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchDtrData = async () => {
        try {
            const today = new Date()
            const dateStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString()
            const dateEnd = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
                23,
                59,
                59,
                999
            ).toISOString()

            const response = await apiClient.get('/overtime/', {
                params: { dateStart, dateEnd }
            })

            const formattedData = response.data
                .map((employee, index) => {
                    const record = employee.dailyTimeRecord?.[0]
                    if (!record) return null

                    return {
                        id: index + 1,
                        name: employee.fullName,
                        timeIn: record.timeIn ? new Date(record.timeIn).toLocaleTimeString() : '-',
                        timeOut: record.timeOut ? new Date(record.timeOut).toLocaleTimeString() : '-',
                        remarks: record.remarks || '-'
                    }
                })
                .filter(Boolean)

            setEmployees(formattedData)
        } catch (err) {
            console.error('Error fetching data:', err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchDtrData()

        socket.on('otAttendanceUpdated', fetchDtrData)
        return () => socket.off('otAttendanceUpdated')
    }, [])

    const columns = [
        {
            field: 'name',
            headerName: 'Employee Name',
            width: 280,
            headerAlign: 'left',
            cellClassName: 'text-sm font-medium text-gray-800'
        },
        {
            field: 'timeIn',
            headerName: 'Time In',
            width: 160,
            renderCell: (params) => (
                <span className="text-green-700 font-semibold">
                    {params.value !== '-' ? params.value : <span className="text-gray-400 italic">-</span>}
                </span>
            )
        },
        {
            field: 'timeOut',
            headerName: 'Time Out',
            width: 160,
            renderCell: (params) => (
                <span className="text-red-700 font-semibold">
                    {params.value !== '-' ? params.value : <span className="text-gray-400 italic">-</span>}
                </span>
            )
        },
        {
            field: 'remarks',
            headerName: 'Remarks',
            width: 170,
            renderCell: (params) => {
                const remark = params.value
                let bgColor = 'bg-gray-100 text-gray-700'

                switch (remark) {
                    case 'Home':
                        bgColor = 'bg-rose-100 text-rose-700'
                        break
                    case 'Office':
                        bgColor = 'bg-emerald-100 text-emerald-700'
                        break
                    case 'Offsite':
                        bgColor = 'bg-sky-100 text-sky-700'
                        break
                }

                return (
                    <span className={`px-3 py-1 rounded-full text-sm font-semibold shadow-sm ${bgColor}`}>
                        {remark}
                    </span>
                )
            }
        }
    ]

    return (
        <Box
            sx={{
                height: '75%',
                width: '100%',
                maxWidth: 900,
                mx: 'auto',
                backgroundColor: '#ffffff',
                borderRadius: 2,
                p: 3,
                boxShadow: 3
            }}
        >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#1f2937' }}>
                Overtime Attendance Today
            </Typography>

            <DataGrid
                rows={employees}
                columns={columns.map((col) => ({ ...col, headerClassName: 'header-bold' }))}
                pageSize={10}
                rowsPerPageOptions={[10]}
                loading={loading}
                disableSelectionOnClick
                sx={{
                    '& .MuiDataGrid-columnHeaders': {
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        backgroundColor: '#f3f4f6',
                        color: '#374151'
                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: '0.95rem',
                        color: '#374151',
                        py: 1
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f9fafb'
                    }
                }}
            />
        </Box>
    )
}

export default OTAttendanceTodayList
